// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2078":"5d7122b6","3484":"707ee0d4"}[chunkId] + ".chunk.css";
};